import React from 'react';
import { hospitals } from '../data/mock';
import { MapPin, Award, Bed, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Hospitals = () => {
  const navigate = useNavigate();
  const featuredHospitals = hospitals.filter(h => h.featured);

  return (
    <section id="hospitals" className="section-padding" style={{ background: 'var(--bg-page)' }}>
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4">Our Partner Hospitals</h2>
          <p className="body-large mx-auto" style={{ maxWidth: '700px', color: 'var(--text-secondary)' }}>
            Partnered with India's leading JCI and NABH accredited hospitals for world-class care
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredHospitals.map((hospital, index) => {
            const colorClasses = ['accent-blue', 'accent-purple', 'accent-orange', 'accent-pink', 'accent-green', 'accent-grey', 'accent-blue'];
            const colorClass = colorClasses[index % colorClasses.length];
            
            return (
              <div 
                key={hospital.id} 
                className={`voice-card ${colorClass}`}
              >
                <div className="mb-3 rounded-lg overflow-hidden" style={{ height: '160px' }}>
                  <img 
                    src={hospital.image} 
                    alt={hospital.name}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="flex items-start justify-between mb-2">
                  <h3 className="heading-3 text-base">{hospital.name}</h3>
                  <span 
                    className="caption px-2 py-1 rounded-full flex items-center gap-1 flex-shrink-0 ml-2"
                    style={{ 
                      background: 'rgba(255, 255, 255, 0.6)',
                      border: '1px solid rgba(0, 0, 0, 0.1)'
                    }}
                  >
                    <Award size={10} />
                    {hospital.accreditation.replace(' Accredited', '')}
                  </span>
                </div>

                <div className="flex items-center gap-2 mb-2">
                  <MapPin size={14} style={{ color: 'var(--text-muted)' }} />
                  <span className="caption" style={{ color: 'var(--text-secondary)' }}>
                    {hospital.location}
                  </span>
                </div>

                <p className="body-small mb-3" style={{ color: 'var(--text-secondary)', fontSize: '0.8rem' }}>
                  {hospital.description}
                </p>

                <div className="grid grid-cols-2 gap-3 mb-3 pt-3" style={{ borderTop: '1px solid rgba(0, 0, 0, 0.1)' }}>
                  <div className="flex items-center gap-2">
                    <Bed size={16} style={{ color: 'var(--text-muted)' }} />
                    <div>
                      <div className="caption font-semibold" style={{ color: 'var(--text-primary)' }}>
                        {hospital.beds}
                      </div>
                      <div className="caption" style={{ color: 'var(--text-muted)', fontSize: '0.65rem' }}>
                        Beds
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <Users size={16} style={{ color: 'var(--text-muted)' }} />
                    <div>
                      <div className="caption font-semibold" style={{ color: 'var(--text-primary)' }}>
                        {hospital.patientsPerYear}
                      </div>
                      <div className="caption" style={{ color: 'var(--text-muted)', fontSize: '0.65rem' }}>
                        Patients/Year
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex flex-wrap gap-1">
                  {hospital.specialties.slice(0, 3).map((specialty, idx) => (
                    <span 
                      key={idx}
                      className="caption px-2 py-1 rounded-full"
                      style={{ 
                        background: 'rgba(255, 255, 255, 0.5)',
                        border: '1px solid rgba(0, 0, 0, 0.1)',
                        fontSize: '0.65rem'
                      }}
                    >
                      {specialty}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-8">
          <button 
            onClick={() => navigate('/hospitals')}
            className="btn-secondary"
          >
            View All Hospitals
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hospitals;